module.exports = __webpack_public_path__ + "static/media/chevron-circle-up.9f80ff15.svg";